import WaveSurfer from 'wavesurfer.js';

export function handleWaveformScroll(
  wavesurfer: WaveSurfer,
  currentZoom: number,
  newZoomCallback: (zoom: number) => void,
  event: WheelEvent,
) {
  event.preventDefault();
  event.stopPropagation();

  const { deltaX, deltaY } = event;
  const delta = Math.abs(deltaX) > Math.abs(deltaY) ? -deltaX : deltaY;

  if (event.ctrlKey || event.metaKey) {
    const newZoom = currentZoom * (delta > 0 ? 0.75 : 1.25);
    wavesurfer.zoom(newZoom);
    newZoomCallback(newZoom);
  } else {
    const skipAmount = Math.abs(delta / 40) / currentZoom;
    if (delta < 0) {
      wavesurfer.skipForward(skipAmount);
    } else {
      wavesurfer.skipBackward(skipAmount);
    }
  }
}
